module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if ( context === "subscription:create" ) { 
__p+=' <h5>'+
((__t=( i18n.tc( "SuccessView", "Installation complete" ) ))==null?'':__t)+
'</h5><p>'+
((__t=( i18n.tc( "SuccessView", "Your device is successfully installed, and can now be used from &quot;My devices&quot;." ) ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( context === "subscription:transfer" ) { 
__p+=' <h5>'+
((__t=( i18n.tc( "SuccessView", "Great success!" ) ))==null?'':__t)+
'</h5><p>'+
((__t=( i18n.tc( "SuccessView", "We've sent a mail on your behalf to %s, concerning the subscription transfer." ).format(email) ))==null?'':__t)+
'</p><p>'+
((__t=( i18n.tc( "SuccessView", "If the transfer does not complete, your subscription will be paused at the next renewal date." ) ))==null?'':__t)+
'</p>	';
 } 
__p+=' ';
 if ( context === "subscription:terminated" ) { 
__p+=' <h5>'+
((__t=( i18n.tc( "SuccessView", "Terminate subscription" ) ))==null?'':__t)+
'</h5><p>'+
((__t=( i18n.tc( "SuccessView", "A subscription has been successfully terminated." ) ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( context === "subscription:replaced" ) { 
__p+=' <h5>'+
((__t=( i18n.tc( "SuccessView", "Subscription Replaced" ) ))==null?'':__t)+
'</h5><p>'+
((__t=( i18n.tc( "SuccessView", "Your subscription has been replaced." ) ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( context === "unit:complaint" ) { 
__p+=' <h5>'+
((__t=( i18n.tc( "SuccessView", "Installation complete" ) ))==null?'':__t)+
'</h5><p>'+
((__t=( i18n.tc( "SuccessView", "The device for this subscription has been successfully changed." ) ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( context === "unit:installed" ) { 
__p+=' <h5>'+
((__t=( i18n.tc( "SuccessView", "Installation complete" ) ))==null?'':__t)+
'</h5><p>'+
((__t=( i18n.tc( "SuccessView", "An email has been sent to the customer with further instructions on how to create a subscription.") ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( context === "migrate:complete" ) { 
__p+=' <h5>'+
((__t=( i18n.tc( "SuccessView", "Update complete" ) ))==null?'':__t)+
'</h5><p>'+
((__t=( i18n.tc( "SuccessView", "Finished updating all your devices to DEFA Link.") ))==null?'':__t)+
'</p><p>'+
((__t=( i18n.tc( "SuccessView", "After updating, all zones were turned off. Please remember to turn on your heating.") ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( context === "updated:capabilities" ) { 
__p+=' <h5>'+
((__t=( i18n.tc( "SuccessView", "Your device has recently changed." ) ))==null?'':__t)+
'</h5><p>'+
((__t=( i18n.tc( "SuccessView", "This device will now reload to reflect the changes." ) ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( context === "application:reviewed" ) { 
__p+=' <p>'+
((__t=( message ))==null?'':__t)+
'</p> ';
 } 
__p+=' <fieldset class="button-wrap"><button class="primary" data-click="success-submit">'+
((__t=( i18n.tc( "SuccessView", "Close" ) ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
